<template>
  <div class="omx-empty" :class="'omx-empty--' + size">
    <div class="omx-empty__icon" :class="'omx-empty__icon--' + tone">
      <b-icon :icon="icon" :size="iconSize" />
    </div>
    <h3 v-if="title" class="omx-empty__title">{{ title }}</h3>
    <p v-if="body" class="omx-empty__body">{{ body }}</p>
    <slot name="body" />
    <div class="omx-empty__actions" v-if="$slots.default">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * OmxEmpty — uniform empty-state surface.
 *
 *   <OmxEmpty icon="folder-open-outline"
 *             :title="$t('projects-view.empty-title')"
 *             :body="$t('projects-view.empty-body')">
 *     <b-button type="is-primary" @click="createNew">＋ New project</b-button>
 *   </OmxEmpty>
 *
 * Props:
 *   icon: MDI icon (default "tray-arrow-down")
 *   title / body: copy
 *   tone: 'neutral' | 'brand' | 'warn'  — colors the icon tile
 *   size: 'sm' | 'md' | 'lg'           — controls spacing & icon size
 *   iconSize: passes through to <b-icon size="…">
 */
export default {
  name: "OmxEmpty",
  props: {
    icon:     { type: String, default: "tray-arrow-down" },
    title:    { type: String, default: null },
    body:     { type: String, default: null },
    tone:     { type: String, default: "neutral" },
    size:     { type: String, default: "md" },
    iconSize: { type: String, default: "is-medium" }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.omx-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  color: $omx-ink-500;

  &--sm { padding: 24px 16px; }
  &--lg { padding: 72px 24px; }

  &__icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    background: $omx-ink-50;
    color: $omx-ink-500;

    &--brand { background: $omx-brand-50;   color: $omx-brand-600; }
    &--warn  { background: $omx-warn-100;   color: $omx-warn-600; }
  }

  &__title {
    margin: 0 0 4px;
    color: $omx-ink-900;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -.005em;
  }
  &__body {
    margin: 0;
    max-width: 380px;
    font-size: 13.5px;
    line-height: 1.5;
  }
  &__actions {
    margin-top: 18px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
